import React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { useSelector } from "react-redux";
const LoadingPage = () => {
  const showLoader = useSelector((state) => state.loader.showLoader);

  return (
    <Backdrop
      sx={{ color: "primary.main", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={showLoader}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default LoadingPage;
